const sites = [
  {
    name: 'Yalobusha Review',
    slug: 'yalobusha-review',
    screencast: {
      path: 'yalobusha-review.mp4',
      width: '1280',
      height: '680'
    },
    link: 'https://yr.olemiss.edu',
    emoji: 'books.png',
    description: "As Lead Editor of the Yalobusha Review, I overhauled the literary journal's digital edition. This custom Wordpress site gave editors more granular control over each issue, improved usability on mobile devices, and updated the overall design while maintaining compatibility with back issues. In addition to designing and building the site, I negotiated its budget with university administration and worked with past editors to define the new aesthetic.",
    tools: ['wordpress','jquery']
  },
  {
    name: 'American Violence',
    slug: 'american-violence',
    screencast: {
      path: 'american-violence.mp4',
      width: '1280',
      height: '680'
    },
    link: 'https://americanviolence.org',
    emoji: 'chart.png',
    description: "I took over the development and maintenance of this data-driven React application in 2018 to ensure a successful launch. I worked with the design team to restructure the app's navigation and mobile experiences, collaborated with researches at Princeton to roll out census-tract level visualizations, and refactored several existing APIs to make them more performant.",
    tools: ['d3js', 'react', 'laravel']
  },
  {
    name: 'King of Pops',
    slug: 'king-of-pops',
    screencast: {
      path: 'king-of-pops.mp4',
      width: '1280',
      height: '624'
    },
    link: null,
    emoji: 'rainbow.png',
    description: "I worked with one other designer to establish the initial web presence for the Atlanta institution, King of Pops. This Rails app included a custom calendar, a live popsicle location map, and a bulk ordering wizard.",
    tools: ['rails','jquery', 'heroku']
  },
  {
    name: 'Laurel Gitlen',
    slug: 'laurel-gitlen',
    screencast: {
      path: 'laurel-gitlen.mp4',
      width: '1280',
      height: '680'
    },
    link: 'http://laurel-gitlen.herokuapp.com',
    emoji: 'painting.png',
    description: "I worked closely with designer John McCusker to build a custom Rails CMS to help the Laurel Gilten better showcase their artists and upcoming exhibitions.",
    tools: ['rails','jquery', 'heroku']
  },
  {
    name: 'Climate Smart Cities Grenada',
    slug: 'grenada',
    screencast: {
      path: 'grenada.mp4',
      width: '1280',
      height: '680'
    },
    link: 'https://www.climatesmartcitiesgrenada.com ',
    emoji: 'island.png',
    description: "I built and helped design Climate Smart Cities Grenada site to help Grenada and the Marron Institute present several climate interventions in the country. Built in Strapi and Vue.js, this app includes a custom Dropbox-like file sharing dashboard for researchers, scientists, and contractors fighting climate change in Grenada.",
    tools: ['nodejs','vuejs', 'heroku']
  },
  {
    name: 'Atlas of Urban Expansion',
    slug: 'atlas',
    screencast: {
      path: 'atlas.mp4',
      width: '1280',
      height: '680'
    },
    link: 'http://atlasofurbanexpansion.org',
    emoji: 'map.png',
    description: "As one of two developers for the Atlas of Urban Expansion, I developed a library of Ruby scripts to automate the creation of over 1,000 interactive maps—saving the client hundreds in Mapbox hosting fees.",
    tools: ['ruby', 'laravel', 'javascript']

  },
]

export default sites;
